import { LINKEDIN_SHARE_URL } from 'src/common/helpers/socials';
import { SocialName } from 'src/common/page-share';
import { ReactComponent as FacebookIcon } from 'src/images/svgs/socials/facebook.svg';
import { ReactComponent as LinkedinIcon } from 'src/images/svgs/socials/linkedin.svg';
import { ReactComponent as TwitterXIcon } from 'src/images/svgs/socials/x-twitter.svg';
import { StyledBigSocialButton, StyledSocialButton, StyledSocialButtonsWrapper, StyledTitle } from './social-media-share.styles';
import type { SocialMediaShareProps } from './social-media-share.types';
export const SocialMediaShare: React.FC<SocialMediaShareProps> = ({
  pageUrl,
  shareDescription,
  isBig = false,
  showTitle = true,
  shareCallback,
  platforms,
  forceColumn = false,
  extraItems
}) => {
  const encodedUrl = encodeURIComponent(pageUrl);
  const encodedDescription = encodeURIComponent(shareDescription);
  const allPlatforms = [{
    name: SocialName.twitter,
    href: `https://twitter.com/intent/tweet?url=${encodedUrl}&via=tryhackme&text=${encodedDescription}&hashtags=tryhackme`,
    icon: <TwitterXIcon />,
    displayName: 'Twitter / X'
  }, {
    name: SocialName.linkedin,
    href: `${LINKEDIN_SHARE_URL}&text=${encodedDescription}%0D%0A${encodedUrl}`,
    icon: <LinkedinIcon />,
    displayName: 'LinkedIn'
  }, {
    name: SocialName.facebook,
    href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}&t=${encodedDescription}`,
    icon: <FacebookIcon />,
    displayName: 'Facebook'
  }];
  const socialPlatforms = platforms ? allPlatforms.filter(p => platforms.includes(p.name)) : allPlatforms;
  return <>
      {showTitle && <StyledTitle>Share on social media</StyledTitle>}
      <StyledSocialButtonsWrapper $forceColumn={forceColumn} data-sentry-element="StyledSocialButtonsWrapper" data-sentry-source-file="social-media-share.tsx">
        {socialPlatforms.map(platform => isBig ? <StyledBigSocialButton key={platform.name} data-social={platform.name} target="_blank" rel="noopener noreferrer" href={platform.href} onClick={() => shareCallback?.(platform.name)}>
              {platform.icon}
              {platform.displayName}
            </StyledBigSocialButton> : <StyledSocialButton key={platform.name} data-social={platform.name} target="_blank" rel="noopener noreferrer" href={platform.href} onClick={() => shareCallback?.(platform.name)}>
              {platform.icon}
            </StyledSocialButton>)}
        {extraItems}
      </StyledSocialButtonsWrapper>
    </>;
};